<template>
  <div id="container">
    <v-dialog v-model="enable" max-width="400" persistent>
      <v-card style="text-align:center">
        <v-icon x-large class="py-2" color="red">block</v-icon>

        <v-card-title
          class="center_btns"
          style="font-weight:700; font-size:17px"
          primary-title
        >
          {{ title }}
          <a href = "mailto: contacto@skolable.com">contacto@skolable.com</a>
        </v-card-title>

        <v-card-text v-show="false" v-html="description"></v-card-text>
      

        <v-card-actions class="center_btns">
          <v-btn v-show="false" class="custom-border" @click="cancel" depressed outline
            >Cerrar</v-btn
          >
          <v-btn
          
            class="custom-border"

            style="font-size:14px; background: #f44336;color:white;"
            depressed
            @click="ok"
            >Entendido</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'title', 'description'],
  data() {
    return {
      enable: this.value,
    }
  },
  watch: {
    value() {
      this.enable = this.value
    },
  },
  methods: {
    cancel() {
      this.$emit('input', !this.value)
      this.$emit('desition', false)
    },
    ok() {
      this.$emit('input', !this.value)
      this.$emit('desition', true)
    },
  },
}
</script>

<style scoped>
.custom-border {
  border-radius: 0.5rem;
  background: #f44336;

  border-color: #ccc !important;
}
.center_btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>
